@if(carregando()){
  <div class="relatorio skeleton">

    <div class="cabecalho-relatorio">
      <div class="sk sk-logo"></div>
      <div class="sk sk-h1"></div>
    </div>

    <div class="conteudo-principal">

      <aside class="coluna-esquerda">
        <div class="sk sk-secao-titulo"></div>
        <div class="sk sk-divisor"></div>

        <div class="sk-tabela-dados">
          @for (item of skLinhas; track $index) {
            <div class="sk-linha-dados">
              <div class="sk sk-label"></div>
              <div class="sk sk-valor" [style.width]="(50 + ($index % 4) * 10) + '%'"></div>
            </div>
          }
        </div>

        <div class="sk sk-secao-titulo sk-mt"></div>
        <div class="sk sk-divisor"></div>

        <div class="sk-cards">
          @for (item of skCards; track $index) {
            <div class="sk sk-card">
              <div class="sk-card-inner">
                <div class="sk-card-icon"></div>
                <div class="sk-card-label"></div>
                <div class="sk-card-qnt"></div>
                <div class="sk-card-porc"></div>
              </div>
            </div>
          }
        </div>
      </aside>

      <main class="coluna-direita">
        <div class="sk sk-secao-titulo"></div>
        <div class="sk sk-divisor"></div>

        <div class="sk-tabela-wrapper">
          <div class="sk-thead">
            @for (item of [1,2,3,4,5,6,7,8]; track $index) {
              <div class="sk-thead-cell">
                <div class="sk sk-thead-text"></div>
              </div>
            }
          </div>

          @for (item of skRows; track $index) {
            <div class="sk-row" [class.sk-row-alt]="$index % 2 === 1">
              @for (c of [1,2,3,4,5,6,7,8]; track $index) {
                <div class="sk-row-cell">
                  <div class="sk sk-row-text" [style.width]="(45 + ($index % 5) * 10) + '%'"></div>
                </div>
              }
            </div>
          }
        </div>
      </main>

    </div>
  </div>
}

@if(erro()){
  <div class="erro-wrapper">{{ erro() }}</div>
}

@if(exportando()){
  <div class="export-overlay">
    <div class="export-card">
      <mat-spinner diameter="40" color="primary"></mat-spinner>
      <div class="export-titulo">Gerando PDF...</div>
      @if(progresso()){
        <div class="export-sub">
          Página {{ progresso()!.atual }} de {{ progresso()!.total }}
        </div>
      }@else{
        <div class="export-sub">Preparando documento...</div>
      }
      <mat-progress-bar
        class="export-bar"
        [mode]="progresso() ? 'determinate' : 'indeterminate'"
        [value]="progressoPct()">
      </mat-progress-bar>
      @if(progresso()){
        <div class="export-pct">{{ progressoPct() }}%</div>
      }
    </div>
  </div>
}

@if(temDados()){
  <div class="relatorio">
    <div class="cabecalho-relatorio">
      <img class="logo-img" src="assets/logo-nova.svg" alt="Claribot" />
      <h1>RELATÓRIO DE DISPARO</h1>
    </div>
    <div class="topo-relatorio">
      <div class="info-strip" #painel>
        <div class="info-bloco">
          <h2 class="secao-titulo">DADOS DO DISPARO</h2>
          <div class="divisor-roxo"></div>
          <table class="tabela-dados">
            <tr>
              <td class="dado-label">TÍTULO DISPARO</td>
              <td class="dado-valor">{{ relatorio()!.dadosDisparo.tituloDisparo ?? '—' }}</td>
            </tr>
            <tr>
              <td class="dado-label">TEMPLATE</td>
              <td class="dado-valor">{{ relatorio()!.dadosDisparo.template?.name ?? '—' }}</td>
            </tr>
            <tr>
              <td class="dado-label">FLUXO</td>
              <td class="dado-valor">{{ relatorio()!.dadosDisparo.fluxo?.nome ?? '—' }}</td>
            </tr>
            <tr>
              <td class="dado-label">DATA ENVIO</td>
              <td class="dado-valor">
                {{ (relatorio()!.dadosDisparo.dataEnvio | date:'dd/MM/yyyy - HH:mm') || '—' }}
              </td>
            </tr>
            <tr>
              <td class="dado-label">N. DE ENVIO</td>
              <td class="dado-valor">
                {{ formatarTelefone(relatorio()!.dadosDisparo.conta?.numero) }}
                @if(relatorio()!.dadosDisparo.conta?.nome){
                  <span> - {{ relatorio()!.dadosDisparo.conta!.nome }}</span>
                }
              </td>
            </tr>
            <tr>
              <td class="dado-label">SETOR</td>
              <td class="dado-valor">{{ relatorio()!.dadosDisparo.setor?.nome ?? '—' }}</td>
            </tr>
          </table>
        </div>
        <div class="info-bloco">
          <h2 class="secao-titulo">RESUMO DO DISPARO</h2>
          <div class="divisor-roxo"></div>
          <div class="resumo-cards">
            <div class="resumo-card">
              <img class="resumo-icon" src="assets/icones/relatorio-disparo/relatorio-disparo-enviado.svg" alt="">
              <span class="resumo-label">Total Enviado</span>
              <span class="resumo-qnt">{{ relatorio()!.resumoDisparo.totalEnviado.qnt }}</span>
              <span class="resumo-porc">{{ relatorio()!.resumoDisparo.totalEnviado.porc | number:'1.0-0' }}%</span>
            </div>
            <div class="resumo-card">
              <img class="resumo-icon" src="assets/icones/relatorio-disparo/relatorio-disparo-entregue.svg" alt="">
              <span class="resumo-label">Entregue</span>
              <span class="resumo-qnt">{{ relatorio()!.resumoDisparo.totalEntregue.qnt }}</span>
              <span class="resumo-porc">{{ relatorio()!.resumoDisparo.totalEntregue.porc | number:'1.0-0' }}%</span>
            </div>
            <div class="resumo-card">
              <img class="resumo-icon" src="assets/icones/relatorio-disparo/relatorio-disparo-lido.svg" alt="">
              <span class="resumo-label">Lido</span>
              <span class="resumo-qnt">{{ relatorio()!.resumoDisparo.totalLido.qnt }}</span>
              <span class="resumo-porc">{{ relatorio()!.resumoDisparo.totalLido.porc | number:'1.0-0' }}%</span>
            </div>
            <div class="resumo-card falha">
              <img class="resumo-icon" src="assets/icones/relatorio-disparo/relatorio-disparo-erro.svg" alt="">
              <span class="resumo-label">Falha</span>
              <span class="resumo-qnt">{{ relatorio()!.resumoDisparo.totalFalhas.qnt }}</span>
              <span class="resumo-porc">{{ relatorio()!.resumoDisparo.totalFalhas.porc | number:'1.0-0' }}%</span>
            </div>
          </div>
        </div>
        @if(mensagemDisparo()){
          <div class="info-bloco info-bloco--mensagem">
            <h2 class="secao-titulo">MENSAGEM DO DISPARO</h2>
            <div class="divisor-roxo"></div>
            <p class="mensagem-texto" [innerHTML]="mensagemHtml()"></p>
          </div>
        }
      </div>
      <div class="painel-acoes">
        <button mat-flat-button class="btn-exportar" (click)="exportarPdf()" [disabled]="exportando()">
          <mat-icon>picture_as_pdf</mat-icon>
          {{ exportando() ? 'Gerando PDF...' : 'Exportar PDF' }}
        </button>
        <button mat-stroked-button class="btn-fechar" (click)="fechar()" [disabled]="exportando()">
          <mat-icon>close</mat-icon>
          Fechar
        </button>
      </div>
    </div>
    <section class="comprovacao-section">
      <h2 class="secao-titulo">COMPROVAÇÕES DE ENVIO</h2>
      <div class="divisor-roxo"></div>

      @if(!exportando()){
        <div class="tabela-scroll">
          <table class="tabela-comprovacao">
            <thead>
              <tr>
                <th class="col-nome">Nome do Contato</th>
                <th class="col-tel">Telefone</th>
                <th class="col-cpf">CPF</th>
                <th class="col-id">ID</th>
                <th class="col-metaid">META ID</th>
                <th class="col-status">STATUS</th>
                <th class="col-date">DATE</th>
                <th class="col-receb">RECEBIMENTO</th>
              </tr>
            </thead>
            <tbody>
              @for (row of comprovacao(); track $index) {
                <tr>
                  <td class="col-nome" [matTooltip]="row.nomeContato ?? '—'">{{ row.nomeContato ?? '—' }}</td>
                  <td class="col-tel" [matTooltip]="formatarTelefone(row.numeroContato)">{{ formatarTelefone(row.numeroContato) }}</td>
                  <td class="col-cpf" [matTooltip]="formatarCpf(row.cpfContato)">{{ formatarCpf(row.cpfContato) }}</td>
                  <td class="col-id" [matTooltip]="row.idMensagem ?? '—'">{{ row.idMensagem ?? '—' }}</td>
                  <td class="col-metaid" [matTooltip]="row.metaIdMensagem ?? '—'">{{ row.metaIdMensagem ?? '—' }}</td>
                  <td class="col-status">
                    @if(row.statusMensagem?.toUpperCase() === 'SENT'){
                      <mat-icon class="status-icon">check</mat-icon>
                    } @else if(row.statusMensagem?.toUpperCase() === 'DELIVERED'){
                      <mat-icon class="status-icon">done_all</mat-icon>
                    } @else if(row.statusMensagem?.toUpperCase() === 'READ'){
                      <mat-icon class="status-icon status-read">done_all</mat-icon>
                    } @else if(row.statusMensagem?.toUpperCase() === 'FAILED'){
                      <mat-icon class="status-icon status-failed">error</mat-icon>
                    } @else if(row.statusMensagem?.toUpperCase() === 'POSSUE_SESSAO'){
                      <img class="status-sessao-icon" src="assets/icones/conato-possue-sessao.svg" alt="Contato já possui sessão aberta" matTooltip="Contato já possui sessão aberta">
                    } @else {
                      {{ traduzirStatus(row.statusMensagem) }}
                    }
                  </td>
                  <td class="col-date" [matTooltip]="(row.dataEnvioMensagem | date:'dd/MM/yyyy - HH:mm') || '—'">{{ (row.dataEnvioMensagem | date:'dd/MM/yyyy - HH:mm') || '—' }}</td>
                  <td class="col-receb" [matTooltip]="(row.dataRecebimentoMensagem | date:'dd/MM/yyyy - HH:mm') || '—'">{{ (row.dataRecebimentoMensagem | date:'dd/MM/yyyy - HH:mm') || '—' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>

    <footer class="rodape-relatorio">
      <span>{{ dataExport() | date:'dd/MM/yyyy - HH:mm' }}{{ usuarioExport ? ' - ' + usuarioExport : '' }}</span>
      <span>disparo: {{ relatorio()!.dadosDisparo.uuid }}</span>
    </footer>
  </div>
}
